import { cloneDeep } from 'lodash';

import FormError from './form-error.model';

class SubTransaction {
  constructor(key) {
    this.key = key;

    this.product = null;
    this.amount = null;

    this.customerProducts = [];
  }
}

class TransferForm {
  constructor(customerProducts) {
    this.fromProduct = null;
    this.subTransactions = [];

    this.customerProducts = cloneDeep(customerProducts);

    // Used by fromCustomerProduct selection.
    this.clonedCustomerProducts = cloneDeep(customerProducts);;

    this.selectedCustomerProducts = [];
    this.error = new FormError();
    this.nextItemKey = 0;

    if (this.customerProducts.length === 1) {
      this.fromProduct = this.customerProducts[0].id;
    }

    this.addSubTransaction();
  }

  addSubTransaction() {
    let subTransaction = new SubTransaction(this.nextItemKey);
    let shallowCopy = cloneDeep(this.customerProducts); //copy by value not reference.
    shallowCopy = shallowCopy.filter(item => !this.selectedCustomerProducts.includes(item.id));
    subTransaction.customerProducts = shallowCopy;

    if (this.customerProducts.length === 1) {
      subTransaction.product = this.customerProducts[0].id;
      subTransaction.currency = this.customerProducts[0].currency;
    }

    this.subTransactions.push(subTransaction);
    this.nextItemKey++;
  }

  removeSubTransaction(subTransaction, index) {
    this.removeFromSelectedProducts(subTransaction.product);
    this.reloadToAllCustomerProducts(subTransaction.product, index);

    for (let i = 0; i < this.subTransactions.length; i++) {
      if (this.subTransactions[i].key === subTransaction.key) {
        this.subTransactions.splice(i, 1);
        break;
      }
    }
  }

  get totalAmount() {
    let totalAmount = 0;

    for (let subTransaction of this.subTransactions) {
      totalAmount += Number(subTransaction.amount);
    }

    return totalAmount;
  }

  get isValid() {
    return this.subTransactions.length > 0;
  }

  get canAddProduct() {
    return this.customerProducts.length > 1;
  }

  get displayDeleteButton() {
    return this.subTransactions.length > 1;
  }

  toPayload() {
    let payload = {
      transfer: {}
    };

    payload['transfer']['from'] = this.fromProduct;

    let subTransactions = {};

    for (let subTransaction of this.subTransactions) {
      subTransactions[subTransaction.key] = {
        product: subTransaction.product,
        amount: subTransaction.amount
      };
    }

    payload['transfer']['to'] = subTransactions;

    return payload;
  }

  //============================================================================
  //  Code Below handles operations when a change in product selection occurs.
  //============================================================================
  onChangedFromCustomerProduct(newValue, oldValue) {
    this.onChangedCustomerProduct(-1, newValue, oldValue);
  }

  onChangedCustomerProduct(index, newValue, oldValue) {
    this.selectedCustomerProducts.push(newValue);
    this.removeFromSelectedProducts(oldValue);
    this.removeFromSelection(newValue, index);
    this.reloadToAllCustomerProducts(oldValue, index);
  }

  removeFromSelection(newValue, index) {
    // Remove CustomerProduct with id matching the newValue within each SubTransactions
    for (let [sIndex, subTransaction] of this.subTransactions.entries()) {
      // This condition will not remove the CustomerProduct from the owning SubTransaction.
      // The reason is that, when we tried to remove it, the ng-model will be affected does
      // will unselect the selection. Apparently, this is the same implementation on OLD AMS.
      if (index !== sIndex) {
        for (let [cIndex, customerProduct] of this.subTransactions[sIndex].customerProducts.entries()) {
          if (customerProduct.id === newValue) {
            this.subTransactions[sIndex].customerProducts.splice(cIndex, 1);
          }
        }
      }
    }

    // Remove from fromCustomerProduct selection
    if (index !== -1) {
      for (let[fIndex, customerProduct] of this.clonedCustomerProducts.entries()) {
        if (customerProduct.id === newValue) {
          let spliced = this.clonedCustomerProducts.splice(fIndex, 1);
        }
      }
    }
  }

  removeFromSelectedProducts(value) {
    if (value) {
      let oldValueIndex = this.selectedCustomerProducts.indexOf(value);
      this.selectedCustomerProducts.splice(oldValueIndex, 1);
    }
  }

  // Push CustomerProduct with id matching the oldValue (if oldValue is not null) within each SubTransactions
  reloadToAllCustomerProducts(oldValue, index) {
    if (oldValue) {
      let oldCustomerProduct = this.getCustomerProductById(oldValue);
      for (let [sIndex, subTransaction] of this.subTransactions.entries()) {
        if (index !== sIndex) {
          subTransaction.customerProducts.push(oldCustomerProduct);
        }
      }
    }

    // Reload to fromCustomerProduct selection
    if (oldValue && index !== -1) {
      let oldCustomerProduct = this.getCustomerProductById(oldValue);
      this.clonedCustomerProducts.push(oldCustomerProduct);
    }
  }

  getCustomerProductById(id) {
    return this.customerProducts.filter(customerProduct => customerProduct.id === id)[0];
  }
}

export default TransferForm;



// WEBPACK FOOTER //
// ./client/app/pages/customer/productwallet/model/form.model.js